(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FeaturevisorSDK"] = factory();
	else
		root["FeaturevisorSDK"] = factory();
})(this, () => {
return 